/*
 * Payment email filters in the URL: teacher=<uuid>, status=<outbox status>, type=<email kind>.
 * Never the teacher's name; the picker shows it once a row names that teacher.
 */
import { LINKED_TEACHER_TEXT, linked_teacher_name, uuid_param } from '../shared/url_query';
import { OUTBOX_KINDS, OUTBOX_STATUSES } from './adapters';

export { LINKED_TEACHER_TEXT };

export const PAYMENT_EMAILS_URL_KEYS = ['teacher', 'status', 'type'];

const known = (list, v) => (list.some((o) => o.value === v) ? v : '');

export const parse_payment_emails_filters = (search) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const get = (k) => (qs.get(k) || '').trim();
  const uuid = uuid_param(get('teacher'));
  return {
    teacher: { teacher_uuid: uuid, display: uuid ? LINKED_TEACHER_TEXT : '' },
    status: known(OUTBOX_STATUSES, get('status')),
    kind: known(OUTBOX_KINDS, get('type'))
  };
};

export const payment_emails_query = ({ teacher_uuid, status, kind }) => ({
  teacher: teacher_uuid || '',
  status: status || '',
  type: kind || ''
});

// A linked teacher's name from the first row that names them; the same object when nothing changes.
export const named_teacher = (teacher, rows) => {
  if (!teacher || !teacher.teacher_uuid || teacher.display !== LINKED_TEACHER_TEXT) return teacher;
  const name = linked_teacher_name(rows, teacher.teacher_uuid);
  return name ? { ...teacher, display: name } : teacher;
};

// The summary names a teacher only once their real name is known.
export const teacher_summary_name = (teacher) =>
  teacher && teacher.display !== LINKED_TEACHER_TEXT ? teacher.display : '';
